import {ref, watch, computed} from '@vue/composition-api'
import store from '@/store'
import {title} from '@core/utils/filter'

// Notification
import {useToast} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useCompaniesList(workspaceId) {
    // Use toast
    const toast = useToast()

    const refCompanyListTable = ref(null)

    // Table Handlers
    const tableColumns = [
        {key: 'companyCode', sortable: true},
        {key: 'name', sortable: true},
        {key: 'email', sortable: true},
        {key: 'phone', sortable: true},
        {key: 'address', sortable: true},
    ]

    const perPage = ref(10)
    const totalCompanies = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const roleFilter = ref(null)
    const planFilter = ref(null)
    const statusFilter = ref(null)

    const dataMeta = computed(() => {
        const localItemsCount = refCompanyListTable.value ? refCompanyListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalCompanies.value,
        }
    })

    const refetchData = () => {
        refCompanyListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
        refetchData()
    })

    const fetchCompanies = (ctx, callback) => {
        store
            .dispatch('company/list', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                role: roleFilter.value,
                plan: planFilter.value,
                status: statusFilter.value,
                workspaceId: workspaceId.value,
            })
            .then(response => {
                const {companies, total} = response
                callback(companies)
                totalCompanies.value = total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching company list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    return {
        fetchCompanies,
        tableColumns,
        perPage,
        currentPage,
        totalCompanies,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refCompanyListTable,

        refetchData,

        // Extra Filters
        roleFilter,
        planFilter,
        statusFilter,
    }
}
